import { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  Divider,
  Autocomplete,
  Typography,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  FormData,
  IDistrict,
  IProvince,
  ITambon,
} from "./MainFormPersonaNewV1";
import DeleteIcon from "@mui/icons-material/Delete";
import { APIEndpointWeb, webapi } from "../../../../client/web";

const webApplicationsOptions = [
  { name: "morProm", label: "หมอพร้อม" },
  { name: "LearnBuddy", label: "สอน.บัดดี้" },
  { name: "his", label: "HIS" },
  { name: "other", label: "อื่นๆ" },
];

const provinceOptions = [
  { label: "กาฬสินธุ์", value: "กาฬสินธุ์" },
  { label: "ขอนแก่น", value: "ขอนแก่น" },
];

const districtOptions = [
  { label: "ยางตลาด", value: "ยางตลาด" },
  { label: "เมือง", value: "เมือง" },
];

const subdistrictOptions = [
  { label: "หัวนาคำ", value: "หัวนาคำ" },
  { label: "ยางตลาด", value: "ยางตลาด" },
];

const titleOptions = [
  { label: "นาย", value: "นาย" },
  { label: "นาง", value: "นาง" },
  { label: "นางสาว", value: "นางสาว" },
];

// interface FormData {
//   title: string;
//   firstName: string;
//   lastName: string;
//   idCard: string;
//   businessLicense: string;
//   address: string;
//   building: string;
//   alley: string;
//   road: string;
//   province: string;
//   district: string;
//   subdistrict: string;
//   postalCode: string;
//   postalCodeElectronic: string;
//   phone: string;
//   webApplications: string;
// }

// const defaultForm: FormData = {
//   title: "",
//   firstName: "",
//   lastName: "",
//   idCard: "",
//   businessLicense: "",
//   address: "",
//   building: "",
//   alley: "",
//   road: "",
//   province: "",
//   district: "",
//   subdistrict: "",
//   postalCode: "",
//   postalCodeElectronic: "",
//   phone: "",
//   webApplications: "",
// };

interface IDataMainFormPersonaNew {
  formData: FormData;
  setFormData: any;
  errors: any;
  setErrors: any;
  allProvince: IProvince[];
}

interface ITambonSuper {
  tambon: ITambon[];
}

interface IDistrictSuper {
  district: IDistrict[];
}

const PersonSignV1: React.FC<IDataMainFormPersonaNew> = ({
  formData,
  setFormData,
  errors,
  setErrors,
  allProvince,
}) => {
  // const [forms, setForms] = useState<FormData[]>([formData]);
  //   const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  const [allDistricts, setAllDistricts] = useState<IDistrictSuper[]>([]);
  const [allTambon, setAllTambon] = useState<ITambonSuper[]>([]);
  const [touched, setTouched] = useState<boolean[]>([false]);
  const [touchedEmail, setTouchedEmail] = useState<boolean[]>([false]);
  const [touchedFristName, setTouchedFristName] = useState<boolean[]>([false]);
  const [touchedLastName, setTouchedLastName] = useState<boolean[]>([false]);
  const [touchedCid, setTouchedCid] = useState<boolean[]>([false]);
  const [touchedLicenseCode, setTouchedLicenseCode] = useState<boolean[]>([
    false,
  ]);
  const [touchedAddress, setTouchedAddress] = useState<boolean[]>([false]);
  const [touchedSoi, setTouchedSoi] = useState<boolean[]>([false]);
  const [touchedStreet, setTouchedStreet] = useState<boolean[]>([false]);
  const [touchedProvince, setTouchedProvince] = useState<boolean[]>([false]);
  const [touchedPrefix, setTouchedPrefix] = useState<boolean[]>([false]);
  const [touchedDistrict, setTouchedDistrict] = useState<boolean[]>([false]);
  const [touchedTambon, setTouchedTambon] = useState<boolean[]>([false]);
  const [loadingDistricts, setLoadingDistricts] = useState<boolean[]>([]);
  const [loadingTambon, setLoadingTambon] = useState<boolean[]>([]);

  const [touchedZipCode, setTouchedZipCode] = useState<boolean[]>([false]);
  const [touchedMobileNumber, setTouchedMobileNumber] = useState<boolean[]>([
    false,
  ]);
  const [touchedMoo, setTouchedMoo] = useState<boolean[]>([false]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          Array.isArray(allProvince) &&
          allProvince.length > 0 &&
          formData &&
          Array.isArray(formData.co_professional) &&
          formData.co_professional.length > 0
        ) {
          // console.log("formData.co_professional", formData.co_professional)
          for (var index in formData.co_professional) {
            const xml = allProvince.find(
              (p: IProvince) =>
                p.province_thai_name ===
                formData.co_professional[parseInt(index)].province
            );
            //  console.log("xml", xml)
            setLoadingDistricts((prev: any) => [...prev, false]);
            setLoadingTambon((prev: any) => [...prev, false]);
            if (xml) {
              await getDataAllDistrict(xml, formData, parseInt(index));
            } else {
              let formDataMock: FormData = formData;
              formDataMock.co_professional[index].province = "";
              formDataMock.co_professional[index].district = "";
              formDataMock.co_professional[index].sub_district = "";
              formDataMock.co_professional[index].zip_code = "";
              setFormData((prev: any) => ({
                ...prev,
                co_professional: formDataMock.co_professional,
              }));
            }
          }
        }
      } catch (error) {
        setFormData((prev: any) => ({
          ...prev,
          co_professional: [],
        }));
      }
    };

    fetchData();
  }, [allProvince]);

  const getDataAllDistrict = async (
    value: IProvince | null,
    dataProvince: FormData | null = null,
    index: number
  ) => {
    // console.log('value sdss:>> ', value?.province_code);
    try {
      setLoadingDistricts((prev) => {
        const newLoadingDistricts = [...prev];
        newLoadingDistricts[index] = true;
        return newLoadingDistricts;
      });
      setLoadingTambon((prev) => {
        const newLoadingTambon = [...prev];
        newLoadingTambon[index] = true;
        return newLoadingTambon;
      });
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllDistrict}${value?.province_code}`
      );
      // console.log("data.result", data.result)
      if (Array.isArray(data.result)) {
        setAllDistricts((prev) => {
          const newDistricts = [...prev];
          newDistricts[index] = { district: data.result };
          return newDistricts;
        });
        if (value && dataProvince) {
          const xml = data.result.find(
            (p: any) =>
              p.district_thai_name ===
              dataProvince.co_professional[index].district
          );
          if (xml) {
            let dataCode: IDistrict = {
              province_code: xml.province_code,
              district_english_name: xml.district_english_name,
              district_thai_name: xml.district_thai_name,
              district_code: xml.district_code,
            };
            await getDataGetAllTambon(dataCode, dataProvince, index);
          } else {
            let formDataMock: FormData = formData;
            formDataMock.co_professional[index].district = "";
            formDataMock.co_professional[index].sub_district = "";
            formDataMock.co_professional[index].zip_code = "";
            setFormData((prev: any) => ({
              ...prev,
              co_professional: formDataMock.co_professional,
            }));
          }
        }
      } else {
        setAllDistricts((prev) => {
          const newDistricts = [...prev];
          newDistricts[index] = { district: [] };
          return newDistricts;
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDistricts((prev) => {
        const newLoadingDistricts = [...prev];
        newLoadingDistricts[index] = false;
        return newLoadingDistricts;
      });
      setLoadingTambon((prev) => {
        const newLoadingTambon = [...prev];
        newLoadingTambon[index] = false;
        return newLoadingTambon;
      });
    }
  };

  const getDataGetAllTambon = async (
    selectedOption: IDistrict | null,
    dataProvince: FormData | null = null,
    index: number
  ) => {
    // console.log("selectedOption", selectedOption)
    try {
      setLoadingTambon((prev) => {
        const newLoadingTambon = [...prev];
        newLoadingTambon[index] = true;
        return newLoadingTambon;
      });

      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllTambon}${selectedOption?.district_code}&province_code=${selectedOption?.province_code}`
      );

      if (Array.isArray(data.result)) {
        // setAllTambon(data.result)
        setAllTambon((prev) => {
          const newTambon = [...prev];
          newTambon[index] = { tambon: data.result };
          return newTambon;
        });
        ///////////////////////////////////////////// ทำครั้งแรก
        if (dataProvince) {
          const xml = data.result.find(
            (p: any) =>
              p.tambon_thai_name ===
              dataProvince.co_professional[index].sub_district
          );
          if (xml) {
            let formDataMock: FormData = formData;
            formDataMock.co_professional[index].zip_code = xml.zip_code;
            setFormData((prev: any) => ({
              ...prev,
              co_professional: formDataMock.co_professional,
            }));
          } else {
            let formDataMock: FormData = formData;
            formDataMock.co_professional[index].sub_district = "";
            formDataMock.co_professional[index].zip_code = "";
            setFormData((prev: any) => ({
              ...prev,
              co_professional: formDataMock.co_professional,
            }));
          }
        }
      } else {
        setAllTambon((prev) => {
          const newTambon = [...prev];
          newTambon[index] = { tambon: [] };
          return newTambon;
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingTambon((prev) => {
        const newLoadingTambon = [...prev];
        newLoadingTambon[index] = false;
        return newLoadingTambon;
      });
    }
  };

  const handleProvinceChange = (
    _: any,
    selectedOption: IProvince | null,
    index: number
  ) => {
    // console.log("errors", errors)
    if (selectedOption) {
      try {
        let errormork: any = errors;
        errormork.co_professional[index].province = false;
        setErrors((prev: any) => ({ ...prev, ...errormork }));
      } catch (error) {
        console.log(error);
      }
      var formDataMock: FormData = formData;
      formDataMock.co_professional[index].province =
        selectedOption.province_thai_name;
      formDataMock.co_professional[index].district = "";
      formDataMock.co_professional[index].sub_district = "";
      formDataMock.co_professional[index].zip_code = "";
      setFormData((prev: any) => ({
        ...prev,
        co_professional: formDataMock.co_professional,
      }));
      getDataAllDistrict(selectedOption, null, index);
    }
  };

  const handleDistrictChange = (
    _: any,
    selectedOption: IDistrict | null,
    index: number
  ) => {
    if (selectedOption) {
      try {
        let errormork: any = errors;
        errormork.co_professional[index].district = false;
        setErrors((prev: any) => ({ ...prev, ...errormork }));
      } catch (error) {
        console.log(error);
      }
      var formDataMock: FormData = formData;
      formDataMock.co_professional[index].district =
        selectedOption.district_thai_name;
      formDataMock.co_professional[index].sub_district = "";
      formDataMock.co_professional[index].zip_code = "";
      setFormData((prev: any) => ({
        ...prev,
        co_professional: formDataMock.co_professional,
      }));
      getDataGetAllTambon(selectedOption, null, index);
    }
  };

  const handleTambonChange = (
    _: any,
    selectedOption: ITambon | null,
    index: number
  ) => {
    if (selectedOption) {
      try {
        let errormork: any = errors;
        errormork.co_professional[index].sub_district = false;
        errormork.co_professional[index].zip_code = false;
        setErrors((prev: any) => ({ ...prev, ...errormork }));
      } catch (error) {
        console.log(error);
      }

      var formDataMock: FormData = formData;
      formDataMock.co_professional[index].sub_district =
        selectedOption.tambon_thai_name;
      formDataMock.co_professional[index].zip_code = selectedOption.zip_code;
      setFormData((prev: any) => ({
        ...prev,
        co_professional: formDataMock.co_professional,
      }));
    }
  };

  const handleAddForm = () => {
    if (
      Array.isArray(formData.co_professional) &&
      formData.co_professional.length < 4
    ) {
      setLoadingDistricts((prev: any) => [...prev, false]);
      setLoadingTambon((prev: any) => [...prev, false]);
      setFormData((prev: any) => ({
        ...prev,
        co_professional: [
          ...prev.co_professional,
          {
            prefix: "",
            firstname_th: "",
            lastname_th: "",
            full_cid: "",
            license_code: "",
            address: "",
            moo: "",
            soi: "",
            street: "",
            sub_district: "",
            district: "",
            province: "",
            zip_code: "",
            email: "",
            mobile_number: "",
          },
        ],
      }));
    }
  };
  const isValidLicenseCode = (value: string): boolean => {
    const regex = /^[a-zA-Zก-๙0-9]+$/;
    return regex.test(value.trim());
  };

  const editData = (index: number, keyOfobj: string, data: string) => {
    setFormData((prev: any) => ({
      ...prev,
      co_professional: prev.co_professional.map((item: any, i: number) =>
        i === index ? { ...item, [keyOfobj]: data } : item
      ),
    }));
    try {
      const regex_license_code = /^[ก-ฮa-zA-Z0-9]{5,10}$/;
      let errormork: any = { ...errors }; // Clone the errors object to avoid direct mutation
      errormork.co_professional[index] = errormork.co_professional[index] || {}; // Make sure the item exists

      // Default the error state for this field to false
      errormork.co_professional[index][keyOfobj] = false;

      if (keyOfobj === "email") {
        if (!validateEmail(data)) {
          errormork.co_professional[index].email = "อีเมลไม่ถูกต้อง";
        } else {
          delete errormork.co_professional[index].email; // Clear email error if valid
        }
      } else if (keyOfobj === "license_code") {
        // ตรวจสอบว่า license_code มีความยาวระหว่าง 5 ถึง 10 ตัวอักษร และตรงกับ regex
        if (
          !regex_license_code.test(data) ||
          data.length < 5 ||
          data.length > 10
        ) {
          errormork.co_professional[index].license_code =
            "กรุณากรอกเลขที่ใบอนุญาต (5-10 ตัวอักษร)";
        } else {
          // ลบ error ถ้าข้อมูลถูกต้อง
          delete errormork.co_professional[index].license_code;
        }
      }

      // Update the errors state with the new error information
      setErrors((prev: any) => ({ ...prev, ...errormork }));
    } catch (error) {
      console.log(error);
    }
  };

  const isValidThaiIdCard = (id: string): boolean => {
    if (!/^[1-9]\d{12}$/.test(id)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(id.charAt(i)) * (13 - i);
    }
    const checkDigit = (11 - (sum % 11)) % 10;

    return checkDigit === parseInt(id.charAt(12));
  };

  // const handleBlur = (index: number) => {
  //   const newTouched = [...touched];
  //   newTouched[index] = true;
  //   setTouched(newTouched);
  // };

  const deleteData = (index: number) => {
    var formDataMock: FormData = formData;
    formDataMock.co_professional.splice(index, 1);

    var allDistrictsMock: IDistrictSuper[] = allDistricts;
    allDistrictsMock.splice(index, 1);

    var allTambonMock: ITambonSuper[] = allTambon;
    allTambonMock.splice(index, 1);

    var loadingDistrictsMock: boolean[] = loadingDistricts;
    loadingDistrictsMock.splice(index, 1);

    var loadingTambonMock: boolean[] = loadingTambon;
    loadingTambonMock.splice(index, 1);
    // console.log(allDistrictsMock)
    // console.log(allTambonMock)

    setFormData((prev: any) => ({
      ...prev,
      co_professional: formDataMock.co_professional,
    }));
    setAllDistricts(allDistrictsMock);
    setAllTambon(allTambonMock);

    setLoadingDistricts(loadingDistrictsMock);
    setLoadingTambon(loadingTambonMock);
  };

  const checkInputNumber = (text: string): boolean => {
    const re = /^(?:[1-9][0-9]*)$/;
    const currValue: string = text;
    if (currValue === "" || re.test(text)) {
      return true;
    } else {
      return false;
    }
  };
  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile: string) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(mobile);
  };

  const validateCid = (cid: string) => {
    const regex = /^[1-9]{1}[0-9]{12}$/;
    return regex.test(cid);
  };
  const handleFocus = (
    setter: React.Dispatch<React.SetStateAction<boolean[]>>,
    index: number
  ) => {
    setter((prev) => {
      const newTouched = [...prev];
      newTouched[index] = true;
      return newTouched;
    });
  };

  // Check if email is invalid
  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        {/* <Grid item xs={12} md={3} sx={{ alignSelf: "center" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Web Application ที่ใช้
          </Typography>
        </Grid> */}
        {/* <Grid item xs={12} md={9}>
          <Grid container spacing={2} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
          {webApplicationsOptions.map((app) => (
              <Grid item key={app.name}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={forms[0].webApplications === app.name}
                      onChange={handleCheckboxChange}
                      name={app.name}
                    />
                  }
                  label={app.label}
                />
              </Grid>
            ))}
          </Grid>
        </Grid> */}
      </Grid>
      <Grid container sx={{ mt: 3 }} alignItems="center">
        <Grid item xs={12}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
            }}
          >
            ผู้ประกอบวิชาชีพร่วม (โปรดระบุถ้ามี)
          </Typography>
        </Grid>
      </Grid>

      {formData.co_professional && formData.co_professional.length > 0
        ? formData.co_professional.map((form, index) => (
            <div key={index}>
              <Grid container spacing={2} alignItems="center" sx={{ mt: 3 }}>
                {/* Label */}
                <Grid item xs={12} sm={4} md={2}>
                  <Typography
                    sx={{
                      bgcolor: "#616161",
                      color: "white",
                      borderRadius: "5px",
                      textAlign: "center",
                      fontSize: "14px",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    บุคคลที่ {index + 1}
                  </Typography>
                </Grid>

                {/* Delete Button */}
                <Grid item xs={12} sm={4} md={2}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => deleteData(index)}
                    sx={{ width: "100%", fontSize: "14px", padding: "6px" }}
                    startIcon={<DeleteIcon sx={{ fontSize: 16 }} />} // ขนาดไอคอนที่เหมาะสม
                  >
                    ลบรายการ
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12} md={8} pt={2}>
                <Divider sx={{ display: { xs: "none", md: "block" } }} />
              </Grid>

              <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
                <Grid item xs={12} sm={2}>
                  <FormControl
                    fullWidth
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].prefix
                    }
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      คำนำหน้าชื่อ <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={form.prefix}
                      label={
                        <span>
                          คำนำหน้าชื่อ <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      // onChange={handleAutocompleteChange(index, "prefix", value)}
                      onChange={(event) =>
                        editData(index, "prefix", event.target.value)
                      }
                      // displayEmpty
                      // variant="outlined"
                      sx={{
                        width: "100%",
                        height: "56px",
                      }}
                      onFocus={() => handleFocus(setTouchedPrefix, index)}
                      error={
                        errors.co_professional &&
                        errors.co_professional[index] &&
                        !!errors.co_professional[index].prefix
                      }
                      // helperText={(errors.co_professional && errors.co_professional[index] && !!errors.co_professional[index].firstname_th) ? "กรุณากรอกชื่อ" : ""}
                    >
                      {titleOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].prefix && (
                        <FormHelperText>กรุณาเลือกคำนำหน้าชื่อ</FormHelperText>
                      )}
                  </FormControl>

                  {/* {touchedPrefix[index] && !form.prefix[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณาเลือกคำนำหน้าชื่อ
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.prefix &&
                    touchedPrefix[index] &&
                    !form.prefix[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณาเลือกคำนำหน้าชื่อ
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} sm={5}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        ชื่อ <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="firstname_th"
                    placeholder="กรุณากรอกชื่อ"
                    value={form.firstname_th}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.firstname_th[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.firstname_th[index] ? "red" : "",
                        },
                      },
                    }}
                    onFocus={() => handleFocus(setTouchedFristName, index)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[A-Za-z\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4E\u0E3Aเแโใไ]*$/;

                      // ถ้าข้อความเป็นตัวอักษรเท่านั้น จะอัพเดตค่าใน form
                      if (regex.test(inputValue)) {
                        editData(index, "firstname_th", inputValue);
                      }
                    }}
                    // onChange={(e) => handleFormChange(index, e)}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].firstname_th
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].firstname_th
                        ? "กรุณากรอกชื่อ"
                        : ""
                    }
                  />

                  {/* {touchedFristName[index] && !form.firstname_th[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกชื่อ
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.firstname_th &&
                    touchedFristName[index] &&
                    !form.firstname_th[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกชื่อ
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} sm={5}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        นามสกุล <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="lastname_th"
                    placeholder="กรุณากรอกนามสกุล"
                    value={form.lastname_th}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.lastname_th[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.lastname_th[index] ? "red" : "",
                        },
                      },
                    }}
                    onFocus={() => handleFocus(setTouchedLastName, index)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[A-Za-z\u0E01-\u0E2E\u0E30-\u0E39\u0E47-\u0E4E\u0E3Aเแโใไ\s]*$/;

                      if (regex.test(inputValue)) {
                        const spaceCount = (inputValue.match(/\s/g) || [])
                          .length;

                        if (
                          !inputValue.startsWith(" ") && //ห้ามมี space ตัวแรก
                          (spaceCount <= 2 || inputValue === "") // space ได้ 2 ครั้ง
                        ) {
                          editData(index, "lastname_th", inputValue);
                        }
                      }
                    }}
                    // error={errors.lastname_th}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].lastname_th
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].lastname_th
                        ? "กรุณากรอกนามสกุล"
                        : ""
                    }
                    // helperText={errors.lastname_th ? "กรุณากรอกนามสกุล" : ""}
                  />

                  {/* {touchedLastName[index] && !form.lastname_th[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกนามสกุล
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.lastname_th &&
                    touchedLastName[index] &&
                    !form.lastname_th[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกนามสกุล
                      </span>
                    )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        เลขประจำตัวประชาชน{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="full_cid"
                    placeholder="กรุณากรอกเลขประจำตัวประชาชน"
                    value={form.full_cid}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.full_cid[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.full_cid[index] ? "red" : "",
                        },
                      },
                    }}
                    onChange={(event) => {
                      if (
                        checkInputNumber(event.target.value) &&
                        event.target.value.length <= 13
                      ) {
                        editData(index, "full_cid", event.target.value);
                      }
                    }}
                    inputProps={{
                      maxLength: 13,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    onFocus={() => handleFocus(setTouchedCid, index)}
                    error={
                      errors.co_professional &&
                      !!errors.co_professional[index] &&
                      !!errors.co_professional[index].full_cid
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].full_cid
                        ? "กรุณากรอกเลขประจำตัวประชาชน"
                        : ""
                    }
                    // onChange={(e) => handleFormChange(index, e)}
                  />

                  {/* {touchedCid[index] && !form.full_cid[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกเลขประจำตัวประชาชน
                </span>
              )}
              {form.full_cid[index] && !validateCid(form.full_cid) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  เลขประจำตัวประชาชนไม่ถูกต้อง
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.full_cid &&
                    touchedCid[index] &&
                    !form.full_cid[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกเลขประจำตัวประชาชน
                      </span>
                    )}
                  {form.full_cid[index] &&
                    !isValidThaiIdCard(form.full_cid) && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        เลขประจำตัวประชาชนไม่ถูกต้อง
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        เลขที่ใบอนุญาตประกอบวิชาชีพ{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="businessLicense"
                    placeholder="กรุณากรอกเลขที่ใบอนุญาต"
                    value={form.license_code}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.license_code[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.license_code[index] ? "red" : "",
                        },
                      },
                    }}
                    // onChange={(event) => {
                    //   const inputValue = event.target.value.trim().replace(/[^ก-ฮa-zA-Z0-9]/g, "").slice(0, 10);

                    //   const regex = /^[ก-ฮa-zA-Z0-9]{5,10}$/;
                    //   if (regex.test(inputValue)) {
                    //     editData(index, "license_code", inputValue);
                    //   } else {
                    //     editData(index, "license_code", inputValue); // Still store it, but it may show an error
                    //   }
                    // }}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[0-9\s]*$/; // อนุญาตเฉพาะตัวเลข
                      if (regex.test(inputValue)) {
                        editData(index, "license_code", inputValue); // ส่งค่าหากผ่านการตรวจสอบ
                      }
                    }}
                    // onInput={(e) => {
                    //   const input = e.target as HTMLInputElement;

                    //   // ตัดช่องว่าง และกรองเฉพาะ ก-ฮ, A-Z, 0-9
                    //   const sanitizedValue = input.value.trim().replace(/[^ก-ฮa-zA-Z0-9]/g, "").slice(0, 10);

                    //   // เซ็ตค่าที่กรองแล้วกลับเข้าไปใน input
                    //   input.value = sanitizedValue;

                    //   // อัปเดตค่าใน form ไม่ว่าจะถูกต้องหรือไม่
                    //   editData(index, "license_code", sanitizedValue);

                    //   // ตรวจสอบความถูกต้อง เพื่อกำหนด error (ภายใน editData จะจัดการให้)
                    //   const regex = /^[ก-ฮa-zA-Z0-9]{5,10}$/;
                    //   if (!regex.test(sanitizedValue)) {
                    //     // หากต้องการแจ้ง error ทันทีเมื่อไม่ถูกต้อง ให้ทำใน editData อยู่แล้ว
                    //     // หรือจะเพิ่มการจัดการเฉพาะตรงนี้ก็ได้ถ้าต้องการ
                    //   }
                    // }}
                    onInput={(e) => {
                      const input = e.target as HTMLInputElement;
                      const sanitizedValue = input.value
                        .trim()
                        .replace(/[^ก-ฮa-zA-Z0-9]/g, "")
                        .slice(0, 10);
                      input.value = sanitizedValue;
                      editData(index, "license_code", sanitizedValue);
                    }}
                    onFocus={() => handleFocus(setTouchedLicenseCode, index)}
                    //  onChange={(e) => handleFormChange(index, e)}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].license_code
                    }
                    helperText={
                      !form.license_code[index] &&
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].license_code
                        ? "กรุณากรอกเลขที่ใบอนุญาต"
                        : ""
                    }
                    inputProps={{
                      maxLength: 10,
                      // pattern: "[a-zA-Zก-๙\\s]+",
                      // inputMode: "text"
                    }}
                  />
                  {touchedLicenseCode[index] &&
                    !errors.co_professional?.[index]?.license_code &&
                    // เงื่อนไขแรก: ถ้ายังไม่ได้กรอกเลขที่ใบอนุญาต
                    (!form.license_code?.[index] ? (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกเลขที่ใบอนุญาต
                      </span>
                    ) : (
                      // เงื่อนไขที่สอง: ถ้ากรอกแล้ว แต่ความยาวไม่ตรงตามเงื่อนไข (5-10 ตัวอักษร)
                      (!form.license_code ||
                        form.license_code.length < 5 ||
                        form.license_code.length > 10) && (
                        <span
                          style={{
                            color: "#d63c44",
                            fontSize: "12px",
                            paddingLeft: 14,
                          }}
                        >
                          {!form.license_code
                            ? ""
                            : "กรุณากรอกเฉพาะตัวอักษรภาษาไทย ตัวเลข หรืออังกฤษ (5-10 ตัว)"}
                        </span>
                      )
                    ))}
                  {/* {!errors.co_professional?.[index]?.license_code && touchedLicenseCode[index] && !form.license_code[index] && (!form.license_code[index] || form.license_code[index].length === 0) && (
                <span style={{ color: "#d63c44", fontSize: "12px", paddingLeft: 14 }}>
                  กรุณากรอกเลขที่ใบอนุญาต
                </span>
              )}
             
              {(!form.license_code || form.license_code.length < 5 || form.license_code.length > 10) && (
                <span style={{ color: "#d63c44", fontSize: "12px", paddingLeft: 14 }}>
                  {!form.license_code
                    ? ""
                    : "กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง (5-10 ตัวอักษร)"}
                </span>
              )} */}

                  {/* {touchedLicenseCode[index] && form.license_code && (
                // แสดงข้อความ "กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง (5-10 ตัวอักษร)" ถ้ากรอกไม่ครบตามเงื่อนไข (5-10 ตัวอักษร)
                (form.license_code.length < 5 || form.license_code.length > 10) && (
                  <span style={{ color: "#d63c44", fontSize: "12px", paddingLeft: 14 }}>
                    กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง (5-10 ตัวอักษร)
                  </span>
                )
              )} */}

                  {/* {!errors.co_professional?.[index]?.email && touchedEmail[index] && !form.email[index] && (
                <span style={{ color: "#d63c44", fontSize: "12px", paddingLeft: 14 }}>
                  กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์
                </span>
              )}
              {form.email[index] && !validateEmail(form.email) && (
                <span style={{ color: "#d63c44", fontSize: "12px", paddingLeft: 14 }}>
                  รูปแบบอีเมลไม่ถูกต้อง
                </span>
              )} */}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        ที่อยู่ <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="address"
                    placeholder="กรุณากรอกที่อยู่"
                    value={form.address}
                    // onChange={(event) => editData(index, "address", event.target.value)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก

                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        editData(index, "address", event.target.value);
                      }
                    }}
                    onFocus={() => handleFocus(setTouchedAddress, index)}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.address[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.address[index] ? "red" : "",
                        },
                      },
                    }}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].address
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].address
                        ? "กรุณากรอกที่อยู่"
                        : ""
                    }
                    // onChange={(e) => handleFormChange(index, e)}
                  />

                  {/* {touchedAddress[index] && !form.address[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกที่อยู่
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.address &&
                    touchedAddress[index] &&
                    !form.address[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกที่อยู่
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        หมู่ / อาคาร <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="moo"
                    placeholder="กรุณากรอกหมู่ / อาคาร"
                    value={form.moo}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.moo[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.moo[index] ? "red" : "",
                        },
                      },
                    }}
                    onFocus={() => handleFocus(setTouchedMoo, index)}
                    // onChange={(event) => editData(index, "moo", event.target.value)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก

                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        editData(index, "moo", event.target.value);
                      }
                    }}
                    // onChange={(e) => handleFormChange(index, e)}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].moo
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].moo
                        ? "กรุณากรอกหมู่ / อาคาร"
                        : ""
                    }
                  />
                  {!errors.co_professional?.[index]?.moo &&
                    touchedMoo[index] &&
                    !form.moo[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกหมู่ / อาคาร
                      </span>
                    )}
                  {/* {touchedMoo[index] && !form.moo[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกหมู่ / อาคาร
                </span>
              )} */}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        ตรอก / ซอย <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="soi"
                    placeholder="กรุณากรอกตรอก / ซอย"
                    value={form.soi}
                    // onChange={(event) => editData(index, "soi", event.target.value)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก

                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        editData(index, "soi", event.target.value);
                      }
                    }}
                    onFocus={() => handleFocus(setTouchedSoi, index)}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.soi[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.soi[index] ? "red" : "",
                        },
                      },
                    }}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].soi
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].soi
                        ? "กรุณากรอกตรอก / ซอย"
                        : ""
                    }
                    // onChange={(e) => handleFormChange(index, e)}
                  />
                  {/* <span style={{ color: !form.soi[index] ? 'red' : '', fontSize: !form.soi[index] ? 12 : '' }}>
                {!form.soi[index] ? "กรุณากรอกตรอก / ซอย" : ""}
              </span> */}
                  {/* {touchedSoi[index] && !form.soi[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกตรอก / ซอย
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.soi &&
                    touchedSoi[index] &&
                    !form.soi[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกตรอก / ซอย
                      </span>
                    )}
                  {/* {form.soi[index] && !validateEmail(form.soi) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  รูปแบบอีเมลไม่ถูกต้อง
                </span>
              )} */}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        ถนน <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="street"
                    placeholder="กรุณากรอกถนน"
                    value={form.street}
                    onFocus={() => handleFocus(setTouchedStreet, index)}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.street[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.street[index] ? "red" : "",
                        },
                      },
                    }}
                    // onChange={(event) => editData(index, "street", event.target.value)}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก

                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        editData(index, "street", inputValue);
                      }
                    }}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].street
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].street
                        ? "กรุณากรอกถนน"
                        : ""
                    }
                    // onChange={(e) => handleFormChange(index, e)}
                  />
                  {/* <span style={{ color: !form.street[index] ? 'red' : '', fontSize: !form.street[index] ? 12 : '' }}>
                {!form.street[index] ? "กรุณากรอกถนน" : ""}
              </span> */}
                  {/* {touchedStreet[index] && !form.street[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกถนน
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.street &&
                    touchedStreet[index] &&
                    !form.street[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกถนน
                      </span>
                    )}
                  {/* {form.email[index] && !validateEmail(form.email) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  รูปแบบอีเมลไม่ถูกต้อง
                </span>
              )} */}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={3}>
                  <FormControl sx={{ minWidth: "100%" }} size="small">
                    {/* <Autocomplete
                  options={provinceOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    provinceOptions.find(
                      (option) => option.value === form.province
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "province", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="จังหวัด" />
                  )}
                /> */}
                    <Autocomplete
                      id="province-select"
                      clearIcon={false}
                      options={allProvince}
                      value={
                        allProvince.find(
                          (option) =>
                            option.province_thai_name === form.province
                        ) || null
                      }
                      getOptionLabel={(option) =>
                        option.province_thai_name || ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.province_code === value.province_code
                      }
                      onChange={async (_, value) => {
                        if (value) {
                          //  await editData(index, "province", value.province_thai_name)
                          await handleProvinceChange("", value, index);
                          // handleFormChange({
                          //   target: {
                          //     name: "province",
                          //     value: value.province_thai_name,
                          //   },
                          // } as React.ChangeEvent<HTMLInputElement>);
                        }
                      }}
                      onFocus={() => handleFocus(setTouchedProvince, index)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              จังหวัด <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          name="province"
                          variant="outlined"
                          fullWidth
                          // error={!!errors["form.province"]}
                          // helperText={errors["form.province"] ? "กรุณาเลือกจังหวัด" : ""}
                          error={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].province
                          }
                          helperText={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].province
                              ? "กรุณาเลือกจังหวัด"
                              : ""
                          }
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "4px",
                              backgroundColor: "#ffffff",
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                  {/* {touchedProvince[index] && !form.province[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณาเลือกจังหวัด
                </span>
              )} */}
                  {!errors.co_professional?.[index]?.province &&
                    touchedProvince[index] &&
                    !form.province[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณาเลือกจังหวัด
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormControl sx={{ minWidth: "100%" }} size="small">
                    {/* <Autocomplete
                  options={districtOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    districtOptions.find(
                      (option) => option.value === form.district
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "district", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="อำเภอ" />
                  )}
                />
 */}
                    <Autocomplete
                      disabled={!form.province || loadingDistricts[index]}
                      clearIcon={false}
                      id="district-select"
                      options={allDistricts[index]?.district || []}
                      getOptionLabel={(option) => option.district_thai_name}
                      value={
                        allDistricts[index]?.district.find(
                          (option) =>
                            option.district_thai_name === form.district
                        ) || null
                      }
                      onChange={(_, value) => {
                        console.log("value", value);
                        handleDistrictChange("", value, index);
                      }}
                      onFocus={() => handleFocus(setTouchedDistrict, index)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              อำเภอ <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          name="district"
                          variant="outlined"
                          fullWidth
                          error={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].district
                          }
                          helperText={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].district
                              ? "กรุณาเลือกอำเภอ"
                              : ""
                          }
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "4px",
                              backgroundColor: "#ffffff",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingDistricts[index] ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                          // error={!!errors["form.district"]}
                          // helperText={errors["form.district"] ? "กรุณาเลือกอำเภอ" : ""}
                        />
                      )}
                    />
                  </FormControl>
                  {/* {touchedDistrict[index] && !form.district[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณาเลือกอำเภอ
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.email &&
                    touchedDistrict[index] &&
                    !form.district[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณาเลือกอำเภอ
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormControl sx={{ minWidth: "100%" }} size="small">
                    {/* <Autocomplete
                  options={subdistrictOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    subdistrictOptions.find(
                      (option) => option.value === form.sub_district
                    ) || null
                  }
                  onChange={(_, value) =>
                    handleAutocompleteChange(index, "sub_district", value)
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="ตำบล / แขวง" />
                  )}
                /> */}

                    <Autocomplete
                      disabled={!form.district || loadingTambon[index]}
                      clearIcon={false}
                      id="subdistrict-select"
                      options={allTambon[index]?.tambon ?? []} // ป้องกัน options เป็น null หรือ undefined
                      value={
                        allTambon[index]?.tambon && Array.isArray(allTambon)
                          ? allTambon[index]?.tambon.find(
                              (option) =>
                                option.tambon_thai_name === form.sub_district
                            ) || null
                          : null
                      }
                      getOptionLabel={(option) => option.tambon_thai_name}
                      onChange={(_, value) => {
                        // if (value) {
                        handleTambonChange("", value, index);
                        //   handleFormChange({
                        //     target: {
                        //       name: "sub_district",
                        //       value: value.tambon_thai_name,
                        //     },
                        //   } as React.ChangeEvent<HTMLInputElement>);
                        // }
                      }}
                      onFocus={() => handleFocus(setTouchedTambon, index)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              ตำบล / แขวง{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          name="sub_district"
                          variant="outlined"
                          fullWidth
                          error={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].district
                          }
                          helperText={
                            errors.co_professional &&
                            errors.co_professional[index] &&
                            !!errors.co_professional[index].district
                              ? "กรุณาเลือกตำบล / แขวง"
                              : ""
                          }
                          sx={{
                            backgroundColor: "#ffffff",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "4px",
                              backgroundColor: "#ffffff",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingTambon[index] ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}

                          //     error={!!errors["form.sub_district"]}
                          // helperText={errors["form.sub_district"] ? "กรุณาเลือกตำบล / แขวง" : ""}
                        />
                      )}
                    />

                    {/* {touchedTambon[index] && !form.sub_district[index] && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกตำบล / แขวง
                  </span>
                )} */}
                    {!errors.co_professional?.[index]?.sub_district &&
                      touchedTambon[index] &&
                      !form.sub_district[index] && (
                        <span
                          style={{
                            color: "#d63c44",
                            fontSize: "12px",
                            paddingLeft: 14,
                          }}
                        >
                          กรุณาเลือกตำบล / แขวง
                        </span>
                      )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    disabled={loadingTambon[index] || !form.sub_district}
                    fullWidth
                    label={
                      <span>
                        รหัสไปรษณีย์ <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="zip_code"
                    placeholder="กรุณากรอกรหัสไปรษณีย์"
                    value={form.zip_code}
                    maxRows={5}
                    onInput={(e) => {
                      const input = e.target as HTMLInputElement;
                      input.value = input.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 5);
                    }}
                    inputProps={{
                      maxLength: 5,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.zip_code[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.zip_code[index] ? "red" : "",
                        },
                      },
                    }}
                    // onChange={(event) => {
                    //   if (checkInputNumber(event.target.value)) {
                    //     editData(index, "zip_code", event.target.value)
                    //   }
                    // }

                    // }
                    // onBlur={() => handleBlur(index)}
                    // onChange={(e) => handleFormChange(index, e)}

                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].zip_code
                    }
                    helperText={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].zip_code
                        ? "กรุณากรอกรหัสไปรษณีย์"
                        : ""
                    }
                  />

                  {/* {touchedZipCode[index] && !form.zip_code[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกรหัสไปรษณีย์
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.zip_code &&
                    touchedZipCode[index] &&
                    !form.zip_code[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกรหัสไปรษณีย์
                      </span>
                    )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        ไปรษณีย์อิเล็กทรอนิกส์{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="email"
                    placeholder="กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                    value={form.email}
                    onChange={(event) => {
                      editData(index, "email", event.target.value);
                    }}
                    // onFocus={() => handleFocusEmail(index)}
                    onFocus={() => handleFocus(setTouchedEmail, index)}
                    // onBlur={() => handleBlur(index)}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.email[index] ? "red" : "", // Red border on error
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.email[index] ? "red" : "", // Red label color on error
                        },
                      },
                    }}
                    // onBlur={() => handleBlur(index)}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].email
                    }
                    helperText={
                      !form.email[index] &&
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].email
                        ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                        : ""
                    }
                    // onChange={(e) => handleFormChange(index, e)}
                  />
                  {/* <span style={{ color: !form.email[index] ? 'red' : '', fontSize: !form.email[index] ? 12 : '' }}>
                {!form.email[index] ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์" : ""}
              </span> */}

                  {/* {!form.email[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์
                </span>
              )} */}
                  {/* {!validateEmail(form.email) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  รูปแบบอีเมลไม่ถูกต้อง
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.email &&
                    touchedEmail[index] &&
                    !form.email[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์
                      </span>
                    )}
                  {form.email[index] && !validateEmail(form.email) && (
                    <span
                      style={{
                        color: "#d63c44",
                        fontSize: "12px",
                        paddingLeft: 14,
                      }}
                    >
                      รูปแบบอีเมลไม่ถูกต้อง
                    </span>
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        หมายเลขโทรศัพท์มือถือ{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="businessLicense"
                    placeholder="กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                    value={form.mobile_number}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: !form.mobile_number[index] ? "red" : "",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        "&.Mui-focused": {
                          color: !form.mobile_number[index] ? "red" : "",
                        },
                      },
                    }}
                    onFocus={() => handleFocus(setTouchedMobileNumber, index)}
                    onChange={(event) => {
                      if (event.target.value.length <= 10) {
                        editData(index, "mobile_number", event.target.value);
                      }
                    }}
                    // error={!!errors.co_professional?.[index]?.mobile_number} // Safely check for the error
                    // helperText={errors.co_professional?.[index]?.mobile_number ? "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง" : ""}
                    // onChange={(e) => handleFormChange(index, e)}
                    error={
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].mobile_number
                    }
                    helperText={
                      !form.mobile_number[index] &&
                      errors.co_professional &&
                      errors.co_professional[index] &&
                      !!errors.co_professional[index].mobile_number
                        ? "กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                        : ""
                    }
                  />

                  {/* {touchedMobileNumber[index] && !form.mobile_number[index] && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  กรุณากรอกหมายเลขโทรศัพท์มือถือ
                </span>
              )}
              {form.mobile_number[index] && !validateMobile(form.mobile_number) && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  หมายเลขโทรศัพท์มือถือไม่ถูกต้อง
                </span>
              )} */}

                  {!errors.co_professional?.[index]?.mobile_number &&
                    touchedMobileNumber[index] &&
                    !form.mobile_number[index] && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        กรุณากรอกหมายเลขโทรศัพท์มือถือ
                      </span>
                    )}
                  {form.mobile_number[index] &&
                    !validateMobile(form.mobile_number) && (
                      <span
                        style={{
                          color: "#d63c44",
                          fontSize: "12px",
                          paddingLeft: 14,
                        }}
                      >
                        หมายเลขโทรศัพท์มือถือไม่ถูกต้อง
                      </span>
                    )}
                </Grid>
              </Grid>
              <Grid
                container
                mt={4}
                gap={4}
                alignItems="center"
                justifyContent={"center"}
              >
                {/* ปุ่ม ลบรายการ อยู่ชิดซ้าย */}

                {/* ปุ่ม เพิ่มรายการ อยู่ตรงกลาง */}
                <Grid item>
                  {formData.co_professional.length - 1 === index ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAddForm}
                      sx={{
                        width: "144px",
                        display:
                          formData.co_professional.length > 0 ? "" : "none",
                      }}
                      startIcon={<AddIcon />}
                      disabled={formData.co_professional.length >= 4}
                    >
                      เพิ่มรายการ
                    </Button>
                  ) : (
                    ""
                  )}
                </Grid>
                {/* <Grid item >
              <Button
                variant="contained"
                color="error"
                onClick={() => deleteData(index)}
                sx={{ width: "144px" }}
                startIcon={<DeleteIcon />}
              >
                ลบรายการ
              </Button>
            </Grid> */}

                {/* Grid item ตรงขวาเพื่อให้เหลือที่ว่าง */}
                {/* <Grid item xs={4} /> */}
              </Grid>
            </div>
          ))
        : ""}

      <Grid
        item
        xs={12}
        sx={{ display: "flex", alignItems: "center", mt: 3, gap: 3 }}
      >
        {/* <Divider sx={{ flex: 1, mr: 2}} /> */}
        {formData.co_professional.length < 1 ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddForm}
            sx={{ width: "144px" }}
            startIcon={<AddIcon />}
            disabled={formData.co_professional.length >= 4}
          >
            เพิ่มรายการ
          </Button>
        ) : (
          ""
        )}

        {/* <Divider sx={{ flex: 1, ml: 2  }} /> */}
      </Grid>
      <Grid container sx={{ mt: 7 }}>
        <Grid item xs={12}>
          <Typography variant="body1">
            *หมายเหตุ : หน่วยบริการฯ สามารถสมัครเข้าร่วมตามนโยบาย “๓๐
            บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว”
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            ผ่านการสมัครโดยตรงกับสำนักงานสาธารณสุขจังหวัด เท่านั้น
            เนื่องจากต้องมีการตรวจสอบเอกสารประกอบการสมัคร
          </Typography>
        </Grid>
      </Grid>
    </form>
  );
};

export default PersonSignV1;
